import { getCookie } from "@insite/client-framework/Common/Cookies";
import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CountryCollectionModel, CountryModel, DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { CurrentCustomerBillTosModel } from "@ucs/Services/GetCurrentCustomerBillTosService";
import { Draft } from "immer";

type UcsState = Readonly<{
    nextAvailableTruck: boolean;
    dateTruckError: string;
    currentCountries: CountryModel[] | [];
    isLoadingCurrentCountries: boolean;
    gridHeight: number;
    isLoadingCurrentCustomerBillTos: boolean;
    currentCustomerBillTos: any;
    requestShipDateForQuote?: string;
    cartPoNumber?: string;
    isLocalSelectedPLP: boolean;
    breadcrumbFilterUrl: BreadcrumbFilterUrl;
    isGeoPermissionDenied?: string;
    dealersDropdown: DealerCollectionModel;
}>;

export interface BreadcrumbFilterUrl {
    productTitle: string;
    searchFilters: string;
}

const initialUcsState: UcsState = {
    nextAvailableTruck: false, dateTruckError: "", currentCountries: [], isLoadingCurrentCountries: false, gridHeight: 0, isLoadingCurrentCustomerBillTos: false, currentCustomerBillTos: [], requestShipDateForQuote: "", cartPoNumber: "", isLocalSelectedPLP: getCookie("localFilterPlp") === "true", breadcrumbFilterUrl: { productTitle: "", searchFilters: "" },
    dealersDropdown: {} as DealerCollectionModel
};

const customReducer = createTypedReducerWithImmer(initialUcsState, {
    "Custom/SetNextAvailableTruck": (draft: Draft<UcsState>, action: { nextAvailableTruck: boolean }) => {
        draft.nextAvailableTruck = action.nextAvailableTruck;
    },
    "Custom/SetDateTruckError": (draft: Draft<UcsState>, action: { dateTruckError: string }) => {
        draft.dateTruckError = action.dateTruckError;
    },
    "Custom/BeginLoadCurrentCountires": (draft: Draft<UcsState>) => {
        draft.isLoadingCurrentCountries = true;
    },
    "Custom/SetCurrentCountries": (draft: Draft<UcsState>, action: { currentCountries: CountryModel[] }) => {
        draft.currentCountries = action.currentCountries;
    },
    "Custom/CompleteLoadCurrentCountires": (draft: Draft<UcsState>, action: { collection: CountryCollectionModel }) => {
        draft.currentCountries = action.collection.countries || [];
        draft.isLoadingCurrentCountries = false;
    },
    "Custom/SetPLPRender": (draft: Draft<UcsState>, action: { gridHeight: number }) => {
        draft.gridHeight = action.gridHeight;
    },
    "Custom/BeginLoadCurrentCustomerBillTos": (draft: Draft<UcsState>) => {
        draft.isLoadingCurrentCustomerBillTos = true;
    },
    "Custom/CompleteLoadCurrentCustomerBillTos": (draft: Draft<UcsState>, action: { collection: CurrentCustomerBillTosModel }) => {
        draft.currentCustomerBillTos = action.collection.users || [];
        draft.isLoadingCurrentCustomerBillTos = false;
    },
    "Custom/SetRequestDeliveryDateForQuote": (draft: Draft<UcsState>, action: { requestShipDateForQuote?: string }) => {
        draft.requestShipDateForQuote = action.requestShipDateForQuote;
    },
    "Custom/SetCartPoNumber": (draft: Draft<UcsState>, action: { cartPoNumber?: string }) => {
        draft.cartPoNumber = action.cartPoNumber;
    },
    "Custom/SetIsLocalSelectedPLP": (draft: Draft<UcsState>, action: { isLocalSelectedPLP: boolean }) => {
        draft.isLocalSelectedPLP = action.isLocalSelectedPLP;
    },
    "Custom/SetBreadcrumbFilterUrl": (draft: Draft<UcsState>, action: { breadcrumbFilterUrl: BreadcrumbFilterUrl }) => {
        draft.breadcrumbFilterUrl = action.breadcrumbFilterUrl;
    },
    "Custom/SetGeoPermission": (draft: Draft<UcsState>, action: { isGeoPermissionDenied?: string }) => {
        draft.isGeoPermissionDenied = action.isGeoPermissionDenied || "";
    },
    "Custom/SetLoadDealersDropdown": (draft: Draft<UcsState>, action: { collection: DealerCollectionModel }) => {
        draft.dealersDropdown = action.collection;
    },
});

(reducers as any).customReducer = customReducer;

export type CustomState = {
    customReducer: UcsState;
} & ApplicationState;

type Reducers = {
    customReducer: typeof customReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;